import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getListTicket, updateDataSearch } from "actions/Ticket";
import { DongBoLichSu } from "./DongBoLichSu";
export const DongBoLichSuDesktopBtn = (data, onSearch) => {

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);

  }
  return (
    <div className="iconbutton-new hidden-mobile-main show-table-main">
      <div className="row">
        <div className="col-sm-12 col-md-9">
          <button
            type="button"
            className="btn btn-border-new"
            onClick={handleShow}
          >
            <i className="mdi mdi-plus"></i> Đồng bộ
          </button>
        </div>
      </div>
      {show && <DongBoLichSu data={data} show={show} onHide={handleClose} />}
    </div>
  );
};
